import { render } from "./file-list.vue?vue&type=template&id=09b9ae4c"
import script from "./file-list.vue?vue&type=script&lang=ts"
export * from "./file-list.vue?vue&type=script&lang=ts"
script.render = render

export default script